import { Box, Group, Progress, Text } from '@mantine/core';
import { numStyle } from '../theme';
import { formatPoints } from '../utils/format';

export interface LeaderboardRow {
  key: string | number;
  name: string;
  sub?: string;
  /** Číslo, podle kterého se řadí a škáluje pruh. */
  value: number;
  /** Co se má zobrazit místo `value` — např. čas 06:52 u stopek. */
  display?: string;
  color?: string | null;
}

interface Props {
  rows: LeaderboardRow[];
  unit?: string;
  /** Pruh dává smysl u bodů, ne u časů — tam je delší = horší. */
  showBars?: boolean;
}

export function Leaderboard({ rows, unit = 'b', showBars = true }: Props) {
  const max = Math.max(...rows.map((r) => r.value), 1);

  return (
    <Box>
      {rows.map((row, i) => (
        <Box
          key={row.key}
          px="md"
          py={7}
          style={{
            position: 'relative',
            borderBottom:
              i === rows.length - 1 ? 'none' : '1px solid var(--mantine-color-default-border)',
          }}
        >
          <span
            style={{
              position: 'absolute', left: 0, top: 0, bottom: 0, width: 3,
              background: row.color || 'transparent',
            }}
          />
          <Group gap={9} wrap="nowrap" align="center">
            <Text
              w={22}
              ta="center"
              fz="xs"
              c={i === 0 ? 'yellow.7' : 'dimmed'}
              fw={i === 0 ? 700 : 400}
              style={numStyle}
            >
              {i + 1}
            </Text>
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text fz="sm" fw={650} truncate lh={1.3}>{row.name}</Text>
              {row.sub && <Text style={{ ...numStyle, fontSize: 10 }} c="dimmed">{row.sub}</Text>}
            </Box>
            <Text fw={700} fz={14.5} style={numStyle} ta="right">
              {row.display ?? formatPoints(row.value)}
              {!row.display && unit && (
                <Text component="span" c="dimmed" fz={11}> {unit}</Text>
              )}
            </Text>
          </Group>
          {showBars && (
            <Progress
              value={Math.max(3, (row.value / max) * 100)}
              size={5}
              mt={4}
              ml={31}
              color={row.color || undefined}
              styles={row.color ? { section: { background: row.color } } : undefined}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}
